import { render, staticRenderFns } from "./dangerousGoods.vue?vue&type=template&id=f3d5800e&"
import script from "./dangerousGoods.vue?vue&type=script&lang=js&"
export * from "./dangerousGoods.vue?vue&type=script&lang=js&"
import style0 from "./dangerousGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports